import * as React from "react";
import "./tab3.scss";

const Tab3 = () => {
    return (
        <div className="Tab3">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-3 pb-1">لینک پست شما</h6>
                    <input type="text" name="" id="" className="Campaign-Input"
                           placeholder="مثال: کمپین روز مادر"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-2 pb-1">توضیحات</h6>
                    <textarea name="" id="" className="Campaign-Input" placeholder="بنویسید ..." cols={10}
                              rows={4}></textarea>
                </div>
            </div>
        </div>
    );
}

export default Tab3;